<template>
  <v-container>
    <v-row no-gutters v-if="is_required == false">
      <v-col 
            cols="auto"
            class="ml-auto mb-1">
        <v-btn text small @click="skip" :style="{color:  bot_setting.main_color}">Skip »</v-btn>
      </v-col>
    </v-row>
    <v-row no-gutters justify="center" align="center">

      <v-col class="pr-2">
        <v-text-field
          ref="input_value"
          v-model="input_value"
          :placeholder="placeholder"
          :error-messages="!checkValid ? error_message: ''"
          solo
          @keyup.enter="submit"
          :autofocus="true"
        ></v-text-field>
      </v-col>
      <v-col 
            cols="auto"
            class="ml-auto mb-7">

        <v-btn dark @click="submit" :style="{backgroundColor: bot_setting.main_color}">Submit</v-btn>
      </v-col>
    </v-row>

    <!--Dialog-->
      <template>
        <v-row justify="center">
          <v-dialog v-model="dialog" persistent max-width="450">
            <template v-slot:activator="{ on }">
            </template>
            <v-card>
              <v-card-text class="pb-0">
                <v-container v-if="addresses != null && addresses.length > 0">
                  <v-row style="font-size:1.2rem; word-break:break-word;">郵便番号から下記の住所が該当しました</v-row>
                  <v-row class="pb-0 mt-5">
                    {{addresses[addressIndex].address1}}<br>
                    {{addresses[addressIndex].address2}}<br>
                    {{addresses[addressIndex].address3}}
                  </v-row>
                  <v-row class="mt-5 mb-0" v-if="addresses.length > 0">正しければ[OK]を押してください。</v-row>
                  <v-row class="mt-2 mb-0" v-if="addresses.length > 1">候補が{{addresses.length}}あります。[キャンセル]で次の住所を表示します。</v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialogOk">OK</v-btn>
                <v-btn color="secondary" text @click="dialogCancel">キャンセル</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template> 

  </v-container>
</template>

<script>
import chat from '@/services/api/chat.js'
import utils from '@/utils/utils.js'

export default {

  name: "AutoAddressByZipcodeInput",

  props: ['placeholder', 'error_message', 'pattern_match', 'bot_setting', 'is_required', 'sub_label', 'label_name', 'question_id', 'answer_data', 'custom_validation'],

  data: () =>({
    input_value: null, 
    checkValid: true,

    dialog: false,

    addresses: [],
    addressIndex: 0,
    error_message_2: ''
  }),

  created(){
    this.checkValid = true
    this.error_message_2 = this.error_message
  },


  methods: {
    skip(){
      this.$emit('skip_input_submitted')
    },
    submit(){
      if (this.validateInput() == true){
        this.fetchAddress()
      }else{
        this.checkValid = false
        this.$nextTick(()=>this.$refs.input_value.focus())
      }
    },

    customValidation(_input_value){
      if (this.custom_validation.length > 0){
        this.error_message_2 = ''
        var temp_answer_data = JSON.parse(JSON.stringify(this.answer_data))
        temp_answer_data.push({ 'key': this.label_name, 'value': _input_value, 'question_id': this.question_id })

        for(var j=0; j < this.custom_validation.length; j++){
          if (this.custom_validation[j].rule != ''){
            var validation_result = utils.runCustomValidation(this.custom_validation[j].rule, temp_answer_data)
            if (validation_result == false){
              this.error_message_2 = this.custom_validation[j].error_message
              return false
            }
          }
        }
      }
      return true
    },

    validateInput(){
      //console.log(this.input_value)
      this.error_message_2 = this.error_message
      this.checkValid = true
      if (this.is_required == true){
        if (this.input_value == null || this.input_value == ""){
          return false
        }
      }
      if (this.pattern_match != null || this.pattern_match != ""){
        var regex = new RegExp(this.pattern_match)
        if (regex.test(this.input_value)){
          if (this.customValidation(this.input_value) == false) {
            this.checkValid = false
            return false
          }else{
            return true
          }
        }else{
          this.checkValid = false
          return false
        }
      }else{
        return true
      }
    },

    fetchAddress(){
      var self = this
      chat.getAddress(this.input_value).then(function (response) {
        // handle success
        //console.log(response);

        self.addresses = response.data.data.results

        if (self.addresses != null && self.addresses.length > 0){
          self.addressIndex = 0
          self.dialog = true
        }else{
          self.checkValid = false
        }
      })
      .catch()
    },

    dialogOk(){
      var userSelect = {
        prefecture_name: this.addresses[this.addressIndex].address1,
        city: this.addresses[this.addressIndex].address2,
        area: this.addresses[this.addressIndex].address3,
        prefecture_code: this.addresses[this.addressIndex].prefcode,
        zipcode: this.addresses[this.addressIndex].zipcode,
      }

      //console.log(userSelect)

      var emitValue = {user_chat_message: JSON.stringify(userSelect), user_chat_value:JSON.stringify(userSelect)}
      this.$emit('auto_address_by_zipcode', emitValue)

      this.dialog = false
      this.checkValid = false
    },

    dialogCancel(){
      //console.log(this.addresses.length)
      //console.log(this.addressIndex)
      if (this.addresses.length > 0 && this.addressIndex < this.addresses.length - 1){

        this.addressIndex += 1
      }else{
        this.dialog = false
        this.checkValid = false
      }
    }

  }

}
</script>